// extracted by mini-css-extract-plugin
module.exports = {"mail_desc":"EmailLabel__mail_desc___2RW-b"};